import { render, staticRenderFns } from "./AttendanceLeaveOfMonth.vue?vue&type=template&id=74237588&scoped=true"
import script from "./AttendanceLeaveOfMonth.vue?vue&type=script&lang=js"
export * from "./AttendanceLeaveOfMonth.vue?vue&type=script&lang=js"
import style0 from "./AttendanceLeaveOfMonth.vue?vue&type=style&index=0&id=74237588&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74237588",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74237588')) {
      api.createRecord('74237588', component.options)
    } else {
      api.reload('74237588', component.options)
    }
    module.hot.accept("./AttendanceLeaveOfMonth.vue?vue&type=template&id=74237588&scoped=true", function () {
      api.rerender('74237588', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentquality/AttendanceLeaveOfMonth.vue"
export default component.exports